import { gql } from '@apollo/client'

export const GET_SPACES = gql`
  query GetSpaces {
    getSpaces {
      id
      alias
      name
      labels {
        id
        name
        alias
        country_codes
      }
    }
  }
`
